import { createFileRoute } from '@tanstack/react-router'
import { Scene3DViewer } from '@/components/3d-editor/Scene3DViewer'

export const Route = createFileRoute(
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { sceneId } = Route.useParams()

  return (
    <div className="h-screen bg-background">
      <Scene3DViewer sceneId={sceneId} />
    </div>
  )
}
